import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';

const lazy = {
    DashboardPage: lazyLoad(async () => {
        const { BusinessIntelligenceDashboardPage } = await import('./BusinessIntelligenceDashboard');

        return { default: BusinessIntelligenceDashboardPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'navigation.analytics-dashboard',
        page: lazy.DashboardPage,
        path: '/business-intelligence',
    },
];
